import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { IconButtonReusableComponent } from "../../buttonReusableComponent/ButtonReusableComponent";
import MainAddDinerReservation from "./MainAddDinerReservation";
import store from "../../../../store/store";
import { SET_DINER_DETAILS } from "../../../../store/types";

export class AddDinerPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
    store.dispatch({
      type: SET_DINER_DETAILS,
      payload: { mobile_number: "", dinerName: "" },
    });
  };

  render() {
    const { open } = this.state;
    return (
      <div>
        {/* <IconButtonReusableComponent
          buttonText="Add Diner"
          onClick={this.onOpenModal}
          buttonType="button"
        /> */}
        <button
          type="button"
          className="btn btn-danger text-normal btn-xs rounded"
          onClick={this.onOpenModal}
        >
          + Add Diner
        </button>
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "add-diner-main-popup closeRemove",
            // closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <MainAddDinerReservation onCloseModal={this.onCloseModal} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default AddDinerPopup;
